import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Small } from 'foundations-components/transitional/components/Small';
import { Flow } from 'signup-constants/Flow';
import { getLegalLink } from '../legal/getLegalLink';
import { getIntegrationName } from '../utils/getIntegrationName';
import { isFlow } from '../utils/isFlow';
import { CustomTermsAndConditions, StyledPrivacyBanner } from './CustomTermsAndConditions';
import { StyledUILink } from './TextInput.styles';
import { usePrivacyBanner } from './usePrivacyBanner';
import { Text } from 'foundations-components/components/Text';
import { useTheme, isTrellisTheme } from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const PrivacyBanner = () => {
  const theme = useTheme();
  const isTrellisThemeEnabled = isTrellisTheme(theme);
  const {
    privacyPolicyTextI18nLabel,
    shouldShowPrivacyBanner,
    handleClickTermsOfService,
    handleClickPrivacyPolicy
  } = usePrivacyBanner();
  if (!shouldShowPrivacyBanner) {
    return null;
  }
  const LegitimateInterest = /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: privacyPolicyTextI18nLabel,
    options: {
      termsOfServiceLink: /*#__PURE__*/_jsx(StyledUILink, {
        hideExternalLinkIcon: true,
        href: getLegalLink('terms-of-service'),
        onClick: handleClickTermsOfService,
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "legal.termsOfServiceLink"
        })
      }, "gdprPolicy"),
      privacyPolicyLink: /*#__PURE__*/_jsx(StyledUILink, {
        external: true,
        hideExternalLinkIcon: true,
        href: getLegalLink('privacy-policy'),
        onClick: handleClickPrivacyPolicy,
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "legal.privacyPolicyLink"
        })
      }, "gdprPolicy"),
      break: /*#__PURE__*/_jsx("br", {})
    }
  });
  if (isFlow(Flow.Integrations)) {
    const integrationName = getIntegrationName();
    return integrationName ? /*#__PURE__*/_jsx(CustomTermsAndConditions, {
      LegitimateInterest: LegitimateInterest,
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "legal.integrationsLegalText",
        options: {
          integrationName
        }
      })
    }) : /*#__PURE__*/_jsx(Text, {
      as: "div",
      textAlign: "center",
      children: /*#__PURE__*/_jsx(StyledPrivacyBanner, {
        "data-test-id": "legitimate-interest",
        children: /*#__PURE__*/_jsx(Small, {
          use: "help",
          children: LegitimateInterest
        })
      })
    });
  }
  return /*#__PURE__*/_jsx(Text, {
    as: "div",
    textAlign: isTrellisThemeEnabled ? 'left' : 'center',
    children: /*#__PURE__*/_jsx(StyledPrivacyBanner, {
      "data-test-id": "legitimate-interest",
      children: /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: LegitimateInterest
      })
    })
  });
};
export default PrivacyBanner;